import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, setToken } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "admin@drabhishekgarg.in", password: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", form);
      setToken(r.data.access_token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white" data-testid="admin-login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[hsl(var(--primary))] text-white">
        <div className="font-display text-3xl">Dr. Abhishek Garg</div>
        <div>
          <ShieldCheck size={48} className="text-[hsl(var(--accent))]" />
          <div className="font-display text-5xl tracking-tight mt-4">Campaign CMS</div>
          <p className="opacity-80 mt-3 max-w-sm">
            Manage supporters, content, gallery, and settings. Secure, lean, doctor-friendly.
          </p>
        </div>
        <div className="text-xs uppercase tracking-widest opacity-70">Authorised access only</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <div>
            <Lock className="text-[hsl(var(--accent))]" size={28} />
            <h1 className="font-display text-3xl mt-2 text-[hsl(var(--primary))]">Admin Sign In</h1>
            <p className="text-sm text-[hsl(var(--fg-muted))]">Restricted to campaign administrators.</p>
          </div>
          <div>
            <Label htmlFor="email" className="uppercase text-[10px] tracking-[0.2em]">Email</Label>
            <Input id="email" type="email" required data-testid="admin-email-input"
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="pw" className="uppercase text-[10px] tracking-[0.2em]">Password</Label>
            <Input id="pw" type="password" required data-testid="admin-password-input"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="w-full bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary-hover))] uppercase tracking-widest rounded-none">
            {busy && <Loader2 size={16} className="mr-2 animate-spin" />}
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}
